var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6266 8.42039V12.0174C16.6266 14.5353 15.184 15.6144 13.0202 15.6144H5.80752C3.64371 15.6144 2.20117 14.5353 2.20117 12.0174V6.9816C2.20117 4.46371 3.64371 3.38461 5.80752 3.38461H10.8564",
    stroke: "rgba(227, 55, 69, 1)",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80664 7.34131L8.06422 9.1398C8.80713 9.72971 10.0261 9.72971 10.769 9.1398L11.6201 8.46357",
    stroke: "rgba(227, 55, 69, 1)",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8227 6.62192C15.8186 6.62192 16.6259 5.81671 16.6259 4.82343C16.6259 3.83015 15.8186 3.02493 14.8227 3.02493C13.8268 3.02493 13.0195 3.83015 13.0195 4.82343C13.0195 5.81671 13.8268 6.62192 14.8227 6.62192Z",
    stroke: "rgba(227, 55, 69, 1)",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewselected);
export default __webpack_public_path__ + "static/media/newselected.465181f86e8cb6b737cf059e311e654f.svg";
export { ForwardRef as ReactComponent };